import {
  Box,
  Card,
  CardMedia,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Grid,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { useContext, useEffect, useState } from "react";
import HeaderAppBar from "./appbar";
import { AuthContext, BackendBaseUrl, ORANGE, ORANGE_HOVER, BLACK, PREMIUM_SHADOW, CARD_SHADOW, BG_LIGHT } from "./global_varibles";
import { alpha } from "@mui/material/styles";
import ScrollToTopButton from "./scrool_button";
import { useNavigate, useParams } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs"; // add Dayjs type
import {
  handleAddItem,
  handleRemoveItem,
  handleNewItemChange,
  handleDecrement,
  handleIncrement,
  handleUserDetailsChange,
  handleDateChange,
  handleCategorySelect,
  handlePriceChange,
  handleQuantityChange,
} from "./order_common_func";

// ---- Types ----
type CategoryMap = Record<
  string,
  { type_id: string | number; serv_id: string | number; item_price: number }
>;

interface OrderItemValues {
  item_name: string;
  item_url: string;
  categories: CategoryMap;
}

type OrderData = Record<string, Record<string, OrderItemValues>>;

interface NewItem {
  itemName: string;
  quantity: number | string;
  unitPrice: number | string;
  totalPrice: number | string;
}

interface SubCategoryState {
  type_id: string | number;
  serv_id: string | number;
  quantity: number;
  price: number;
  selectedCategory: string | null;
}

type ItemState = {
  selectedCategory?: string | null;
  price?: number;
  serv_id?: string | number;
} & Record<string, SubCategoryState>;

type ItemsState = Record<string, Record<string, ItemState>>;

interface CustomerDetailsRaw {
  name: string;
  phone: string;
  address: string;
  deliveryDate: string | Date;
}

interface ResponseData {
  strctured_data: {
    order_data: OrderData;
  };
  order_details: {
    customer_details: CustomerDetailsRaw;
    ordered_items_data?: ItemsState;
    other_ord_items?: NewItem[];
    other_charges?: unknown;
    discount?: unknown;
  };
}

interface UserDetails {
  name: string;
  phone: string;
  address: string;
  deliveryDate: Dayjs;
}

function GenerateOrderCards({ response_data }: { response_data: ResponseData }) {
  const order_data = response_data.strctured_data.order_data;
  const customer_details = response_data.order_details.customer_details;
  const ordered_items_data = response_data.order_details.ordered_items_data;
  const other_ord_items = response_data.order_details.other_ord_items;
  const other_charges = response_data.order_details.other_charges;
  const discount = response_data.order_details.discount;
  console.log("customer_details", customer_details);
  const navigate = useNavigate();

  const [newItems, setNewItems] = useState<NewItem[]>(() => {
    const storedNewItems = localStorage.getItem("edit_new_items");
    if (storedNewItems) {
      try {
        return JSON.parse(storedNewItems) as NewItem[];
      } catch {
        return [];
      }
    } else if (other_ord_items) {
      return other_ord_items as NewItem[];
    } else {
      return [];
    }
  });

  const [items, setItems] = useState<ItemsState>(() => {
    const storedItems = localStorage.getItem("edit_current_order_items");
    if (storedItems) {
      try {
        return JSON.parse(storedItems) as ItemsState;
      } catch {
        // fall through to rebuild
      }
    }
    const initialItems: ItemsState = {};
    Object.entries(order_data).forEach(([category, categoryDetails]) => {
      initialItems[category] = {};
      Object.entries(categoryDetails).forEach(([item_id, itemDetails]) => {
        initialItems[category][item_id] = {};
        Object.entries(itemDetails.categories).forEach(
          ([category_key, category_value]) => {
            if (ordered_items_data?.[category]?.[item_id]?.[category_key]) {
              initialItems[category][item_id]["selectedCategory"] =
                ordered_items_data[category][item_id]["selectedCategory"];
              initialItems[category][item_id]["price"] =
                ordered_items_data[category][item_id]["price"];
              initialItems[category][item_id]["serv_id"] =
                ordered_items_data[category][item_id]["serv_id"];
              initialItems[category][item_id][category_key] =
                ordered_items_data[category][item_id][category_key];
            } else {
              initialItems[category][item_id][category_key] = {
                type_id: category_value.type_id,
                serv_id: category_value.serv_id,
                quantity: 0,
                price: category_value.item_price,
                selectedCategory: null,
              };
            }
          }
        );
      });
    });
    return initialItems;
  });

  const [selectedCategory, setSelectedCategory] = useState<string>(
    Object.keys(order_data)[0] || ""
  );

  console.log("items", items);

  const [user_details, setUserDetails] = useState<UserDetails>(() => {
    const savedDetails = localStorage.getItem("edit_user_details");
    if (savedDetails) {
      const parsed = JSON.parse(savedDetails) as {
        name: string;
        phone: string;
        address: string;
        deliveryDate: string | Date;
      };
      return {
        ...parsed,
        deliveryDate: dayjs(parsed.deliveryDate),
      };
    } else if (customer_details && Object.keys(customer_details).length > 0) {
      return {
        ...customer_details,
        deliveryDate: dayjs(customer_details.deliveryDate),
      } as UserDetails;
    } else {
      return {
        name: "",
        phone: "",
        address: "",
        deliveryDate: dayjs(),
      };
    }
  });

  console.log("user details", user_details);

  // Save user_details to localStorage whenever it changes
  // useEffect(() => {
  //   localStorage.setItem("edit_user_details", JSON.stringify(user_details));
  // }, [user_details]);

  // Handle category filter selection
  const handleFilterChange = (category: string) => {
    setSelectedCategory(category);
  };

  // useEffect(() => {
  //   localStorage.setItem("current_order_items", JSON.stringify(items));
  // }, [items]);

  const handleOrderSummary = () => {
    if (
      !user_details.phone ||
      !user_details.deliveryDate ||
      user_details.phone.length !== 10
    ) {
      // Show an error message if phone or delivery date is missing
      alert("enter valid Phone number and Delivery Date are required.");
      return;
    }
    localStorage.setItem("edit_current_order_items", JSON.stringify(items));
    localStorage.setItem("edit_new_items", JSON.stringify(newItems));
    localStorage.setItem("other_charges", JSON.stringify(other_charges));
    localStorage.setItem("discount", JSON.stringify(discount));
    localStorage.setItem("edit_user_details", JSON.stringify(user_details));

    navigate("/summary");
  };

  return (
    <Box sx={{ width: "100%", bgcolor: BG_LIGHT, minHeight: '100vh', pb: 8 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 1200,
          mx: "auto",
          mt: { xs: 0, sm: 3 },
          p: { xs: 2, sm: 4 },
          boxSizing: "border-box",
          borderRadius: { xs: 0, sm: 4 },
          boxShadow: PREMIUM_SHADOW,
          overflow: "hidden",
          backgroundColor: "#fff",
        }}
      >
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 800, 
            mb: 4, 
            color: '#1e293b', 
            textAlign: 'center',
            letterSpacing: '-0.025em'
          }}
        >
          Edit Your Order
        </Typography>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid container spacing={3} sx={{ maxWidth: 1000, mx: 'auto' }}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Full Name"
                name="name"
                variant="outlined"
                value={user_details.name}
                onChange={(e) => handleUserDetailsChange(setUserDetails, e)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineIcon sx={{ color: ORANGE }} />
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                  "& .MuiOutlinedInput-root": { 
                    borderRadius: 3,
                    bgcolor: alpha(BG_LIGHT, 0.5),
                    transition: 'all 0.2s',
                    '&:hover': { bgcolor: alpha(BG_LIGHT, 0.8) },
                    '&.Mui-focused': { bgcolor: '#fff' }
                  } 
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phone"
                type="number"
                required
                variant="outlined"
                value={user_details.phone}
                onChange={(e) => handleUserDetailsChange(setUserDetails, e)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIphoneIcon sx={{ color: ORANGE }} />
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                  "& .MuiOutlinedInput-root": { 
                    borderRadius: 3,
                    bgcolor: alpha(BG_LIGHT, 0.5),
                    transition: 'all 0.2s',
                    '&:hover': { bgcolor: alpha(BG_LIGHT, 0.8) },
                    '&.Mui-focused': { bgcolor: '#fff' }
                  } 
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <DatePicker
                label="Delivery Date"
                value={user_details.deliveryDate}
                onChange={(newValue) =>
                  handleDateChange(setUserDetails, newValue ?? dayjs())
                }
                slotProps={{ 
                  textField: { 
                    fullWidth: true, 
                    required: true,
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CalendarMonthOutlinedIcon sx={{ color: ORANGE }} />
                        </InputAdornment>
                      ),
                    }
                  } 
                }}
                sx={{ 
                  "& .MuiOutlinedInput-root": { 
                    borderRadius: 3,
                    bgcolor: alpha(BG_LIGHT, 0.5),
                    transition: 'all 0.2s',
                    '&:hover': { bgcolor: alpha(BG_LIGHT, 0.8) },
                    '&.Mui-focused': { bgcolor: '#fff' }
                  } 
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                label="Pickup Address"
                name="address"
                variant="outlined"
                value={user_details.address}
                onChange={(e) => handleUserDetailsChange(setUserDetails, e)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationOnOutlinedIcon sx={{ color: ORANGE }} />
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                  "& .MuiOutlinedInput-root": { 
                    borderRadius: 3,
                    bgcolor: alpha(BG_LIGHT, 0.5),
                    transition: 'all 0.2s',
                    '&:hover': { bgcolor: alpha(BG_LIGHT, 0.8) },
                    '&.Mui-focused': { bgcolor: '#fff' }
                  } 
                }}
              />
            </Grid>
          </Grid>
        </LocalizationProvider>

        {/* Add Button Section */}
        <Box sx={{ mt: 6, mb: 4, textAlign: 'center' }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleAddItem(setNewItems)}
            sx={{
              bgcolor: ORANGE,
              fontWeight: 800,
              px: { xs: 3, sm: 4 },
              py: 1.5,
              borderRadius: 3,
              textTransform: "none",
              fontSize: '1rem',
              boxShadow: `0 8px 16px ${alpha(ORANGE, 0.25)}`,
              transition: 'all 0.3s',
              "&:hover": { 
                bgcolor: ORANGE_HOVER,
                transform: 'translateY(-2px)',
                boxShadow: `0 12px 20px ${alpha(ORANGE, 0.35)}`,
              },
            }}
          >
            Add Extra Item
          </Button>

          {/* Dynamic Item Rows */}
          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 800, mx: 'auto' }}>
            {newItems.map((item, index) => (
              <Box
                key={index}
                sx={{ 
                  display: "flex", 
                  gap: 2, 
                  alignItems: "center",
                  p: 2,
                  bgcolor: alpha(BG_LIGHT, 0.6),
                  borderRadius: 3,
                  border: `1px solid ${alpha(ORANGE, 0.1)}`
                }}
              >
                <TextField
                  fullWidth
                  label="Item Name"
                  size="small"
                  value={item.itemName}
                  onChange={(e) => handleNewItemChange(setNewItems, index, "itemName", e.target.value)}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: '#fff' } }}
                />
                <TextField
                  label="Qty"
                  type="number"
                  size="small"
                  sx={{ width: 80, "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: '#fff' } }}
                  value={item.quantity}
                  inputProps={{ step: "any" }}
                  onChange={(e) => {
                    const newQty = e.target.value;
                    handleNewItemChange(setNewItems, index, "quantity", newQty);
                    // Live update totalPrice
                    const q = Number(newQty) || 0;
                    const p = Number(item.unitPrice) || 0;
                    handleNewItemChange(setNewItems, index, "totalPrice", parseFloat((q * p).toFixed(2)));
                  }}
                />
                <TextField
                  label="Unit Price"
                  type="number"
                  size="small"
                  sx={{ width: 100, "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: '#fff' } }}
                  value={item.unitPrice}
                  onChange={(e) => {
                    const newPrice = e.target.value;
                    handleNewItemChange(setNewItems, index, "unitPrice", newPrice);
                    // Live update totalPrice
                    const q = Number(item.quantity) || 0;
                    const p = Number(newPrice) || 0;
                    handleNewItemChange(setNewItems, index, "totalPrice", parseFloat((q * p).toFixed(2)));
                  }}
                  InputProps={{
                    inputProps: { step: "any" },
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                  }}
                />
                <IconButton 
                  onClick={() => handleRemoveItem(setNewItems, index)}
                  sx={{ color: '#ef4444', "&:hover": { bgcolor: alpha('#ef4444', 0.1) } }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Category Selection */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 1.5,
            mb: 5,
            mt: 2,
            flexWrap: "wrap",
          }}
        >
          {Object.keys(order_data).map((category) => (
            <Button
              key={category}
              variant={selectedCategory === category ? "contained" : "outlined"}
              onClick={() => handleFilterChange(category)}
              sx={{ 
                borderRadius: 2.5,
                px: 3,
                py: 1,
                fontWeight: 700,
                textTransform: 'none',
                ...(selectedCategory === category ? {
                  bgcolor: ORANGE,
                  boxShadow: `0 4px 12px ${alpha(ORANGE, 0.3)}`,
                  "&:hover": { bgcolor: ORANGE_HOVER }
                } : {
                  color: "#64748b",
                  borderColor: alpha("#64748b", 0.3),
                  "&:hover": { borderColor: ORANGE, color: ORANGE }
                })
              }}
            >
              {category}
            </Button>
          ))}
        </Box>

        {/* Items List */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            flexDirection: "column",
            alignContent: "center",
            marginBottom: 10,
          }}
        >
          {Object.entries(order_data[selectedCategory] || {}).map(
            ([item_id, item_values]) => {
              return (
                <Card
                  key={item_id}
                  sx={{
                    width: "100%",
                    maxWidth: 800,
                    mx: "auto",
                    mb: 3,
                    display: "flex",
                    flexDirection: { xs: 'column', sm: 'row' },
                    borderRadius: 4,
                    border: `1px solid ${alpha(ORANGE, 0.08)}`,
                    boxShadow: CARD_SHADOW,
                    overflow: "hidden",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    backgroundColor: '#fff',
                    "&:hover": {
                      borderColor: alpha(ORANGE, 0.3),
                      boxShadow: PREMIUM_SHADOW,
                      transform: "translateY(-4px)"
                    }
                  }}
                >
                  {/* Left Side - Image Container */}
                  <Box
                    sx={{
                      width: { xs: '100%', sm: 180 },
                      height: { xs: 160, sm: 'auto' },
                      bgcolor: alpha(BG_LIGHT, 0.6),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 2,
                      borderRight: { sm: `1px solid ${alpha(ORANGE, 0.05)}` }
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={(item_values as OrderItemValues).item_url}
                      sx={{
                        width: 'auto',
                        height: '100%',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: "contain",
                        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.08))'
                      }}
                    />
                  </Box>

                  {/* Right Side - Content */}
                  <Box sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: BLACK, letterSpacing: '-0.01em' }}>
                        {(item_values as OrderItemValues).item_name || ""}
                      </Typography>

                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                        {Object.entries((item_values as OrderItemValues).categories).map(([subCategory]) => (
                          <Button
                            key={subCategory}
                            variant={items[selectedCategory]?.[item_id]?.selectedCategory === subCategory ? "contained" : "outlined"}
                            size="small"
                            onClick={() => handleCategorySelect(setItems, selectedCategory, item_id, subCategory, order_data)}
                            sx={{ 
                              borderRadius: 2,
                              px: 2,
                              fontWeight: 700,
                              textTransform: 'none',
                              fontSize: '0.75rem',
                              ...(items[selectedCategory]?.[item_id]?.selectedCategory === subCategory ? {
                                bgcolor: ORANGE,
                                "&:hover": { bgcolor: ORANGE_HOVER }
                              } : {
                                color: "#64748b",
                                borderColor: alpha("#64748b", 0.2),
                              })
                            }}
                          >
                            {subCategory}
                          </Button>
                        ))}
                      </Box>
                    </Box>

                    {/* Controls Row */}
                    {Object.entries((item_values as OrderItemValues).categories).map(([subCategory]) => {
                      const isSelected = items[selectedCategory]?.[item_id]?.selectedCategory === subCategory;
                      if (!isSelected) return null;

                      return (
                        <Box 
                          key={subCategory} 
                          sx={{ 
                            mt: 'auto',
                            pt: 2,
                            borderTop: `1px solid ${alpha(BLACK, 0.05)}`,
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center' 
                          }}
                        >
                          <TextField
                            size="small"
                            label="Price"
                            value={items[selectedCategory]?.[item_id]?.[subCategory]?.price ?? ""}
                            onChange={(e) => handlePriceChange(setItems, selectedCategory, item_id, subCategory, e.target.value)}
                            InputProps={{
                              startAdornment: <InputAdornment position="start"><Typography sx={{ color: ORANGE, fontWeight: 700 }}>₹</Typography></InputAdornment>,
                            }}
                            sx={{ width: 100, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                          />

                          <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: alpha(BG_LIGHT, 0.8), borderRadius: 3, p: 0.5 }}>
                            <IconButton 
                              size="small"
                              onClick={() => handleDecrement(setItems, selectedCategory, item_id, subCategory)}
                              sx={{ 
                                bgcolor: '#fff', 
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                color: '#ef4444',
                                "&:hover": { bgcolor: alpha('#ef4444', 0.1) }
                              }}
                            >
                              <RemoveIcon sx={{ fontSize: 20 }} />
                            </IconButton>
                            
                            <TextField
                              type="number"
                              variant="standard"
                              value={items[selectedCategory]?.[item_id]?.[subCategory]?.quantity ?? 0}
                              onChange={(e) => handleQuantityChange(setItems, selectedCategory, item_id, subCategory, parseInt(e.target.value, 10) || 0)}
                              InputProps={{ disableUnderline: true }}
                              sx={{ 
                                width: 40, 
                                mx: 1,
                                "& input": { textAlign: 'center', fontWeight: 800, color: BLACK }
                              }}
                            />

                            <IconButton 
                              size="small"
                              onClick={() => handleIncrement(setItems, selectedCategory, item_id, subCategory)}
                              sx={{ 
                                bgcolor: ORANGE, 
                                boxShadow: `0 4px 8px ${alpha(ORANGE, 0.2)}`,
                                color: '#fff',
                                "&:hover": { bgcolor: ORANGE_HOVER }
                              }}
                            >
                              <AddIcon sx={{ fontSize: 20 }} />
                            </IconButton>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Card>
              );
            }
          )}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Button
              variant="contained"
              onClick={handleOrderSummary}
              sx={{
                width: { xs: "100%", sm: "60%", md: "40%" },
                position: "fixed",
                bottom: 16,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 1000,
                borderRadius: 4,
                py: 2,
                fontWeight: 800,
                bgcolor: BLACK,
                color: "#ff8c00",
                boxShadow: `0 10px 25px ${alpha(BLACK, 0.4)}`,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                textTransform: 'none',
                fontSize: '1.1rem',
                "&:hover": { 
                  bgcolor: "#1a1f26",
                  transform: "translateX(-50%) translateY(-4px)",
                  boxShadow: `0 15px 35px ${alpha(BLACK, 0.5)}`,
                },
                "&::after": {
                  content: '"→"',
                  ml: 1.5,
                  fontSize: '1.2rem',
                  transition: 'margin 0.3s',
                },
                "&:hover::after": {
                  ml: 2.5
                }
              }}
            >
              Order Summary
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}

function EditOrder() {
  const authContext = useContext(AuthContext);
  const isAuthinticated = authContext?.isAuthinticated;
  const [structData, setStructData] = useState<any>({});
  const [error, setError] = useState<string | null>(null);
  const { ord_id } = useParams<{ ord_id: string }>();

  // New state for form fields

  const getStructuredData = async () => {
    try {
      const backend_url = `${BackendBaseUrl}/update-order?ord_id=${ord_id}`;
      const response = await fetch(backend_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setStructData(responseData);
        localStorage.setItem(
          "structuredData",
          JSON.stringify(responseData.strctured_data)
        );
        console.log("data set succefuelly");
        console.log("response", responseData);
        setError(null);
      } else {
        setError("Error in fetching data");
      }
    } catch (error) {
      setError("Server Not Found");
    }
  };

  useEffect(() => {
    getStructuredData();
  }, []);

  return (
    <Box>
      <HeaderAppBar />
      {isAuthinticated ? (
        error ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            <Typography variant="h4">{error}</Typography>
          </Box>
        ) : structData.strctured_data ? (
          <Box>
            <GenerateOrderCards response_data={structData as ResponseData} />
            <ScrollToTopButton />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            <Typography>Loading...</Typography>
          </Box>
        )
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 30,
          }}
        >
          <Typography variant="h4">Not Allowed</Typography>
        </Box>
      )}
    </Box>
  );
}

export default EditOrder;
